import { render, staticRenderFns } from "./VesselLaborDetail.vue?vue&type=template&id=2c43a50f"
import script from "./VesselLaborDetail.vue?vue&type=script&lang=js"
export * from "./VesselLaborDetail.vue?vue&type=script&lang=js"
import style0 from "./VesselLaborDetail.vue?vue&type=style&index=0&id=2c43a50f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports